import { fetchPaymentMethodsApi, getCitiesApi } from '@apis/api-helper.js';
import { strings } from '@constants/strings.js';
import tenantConfig from 'data/customizer/tenant-config';

export const ordersTableColumns = (t) => [
  {
    title: t(strings.order_id),
    dataIndex: strings.order_id,
    fixed: 'left',
  },
  {
    title: t(strings.invoice_id),
    dataIndex: strings.invoice_id,
  },
  {
    title: t(strings.line_items),
    dataIndex: strings.line_items,
    width: 100,
  },
  {
    title: t(strings.order_price),
    dataIndex: strings.order_price,
  },
  {
    title: t(strings.buyer),
    dataIndex: strings.buyer,
    width: 400,
  },
  {
    title: t(strings.placed_on),
    dataIndex: strings.placed_on,
  },
  {
    title: t(strings.status),
    dataIndex: strings.status,
  },
  {
    title: t(strings.actions),
    dataIndex: strings.actions,
    fixed: 'right',
  },
];

export const ORDER_STATUSES = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  SHIPMENT_CREATED: 'shipment-created',
  READY_FOR_PICKUP: 'ready-for-pickup',
  DISPATCHED: 'dispatched',
  DELIVERED: 'delivered',
  RETURNED: 'returned',
  CANCELLED: 'cancelled',
};

export const ORDER_DISPOSITIONS = {
  PENDING: 'pending',
  AWAITING_SELLER_CONFIRMATION: 'awaiting-seller-confirmation',
  AWAITING_BUYER_CONFIRMATION: 'awaiting-buyer-confirmation',
  ACCEPTED_BY_SELLER: tenantConfig?.order_statuses?.accepted_by_seller?.slug,
  SHIPMENT_CREATED: 'shipment-created',
  READY_FOR_PICKUP: 'ready-for-pickup',
  DISPATCHED: 'dispatched',
  DELIVERED: 'delivered',
  RETURNED: 'returned',
  CANCELLED: 'cancelled',
  PAYMENT_FAILED: 'payment-failed',
  PAYMENT_PENDING: 'payment-pending',
};

export const MANAGE_ORDERS_FILTERS_LIST = ({
  cities = [],
  setCities,
  paymentMethods = [],
  setPaymentMethods,
  warehouses = [],
  setWarehouses,
  dispositions = [],
  storeId = 1,
}) => [
  {
    type: 'input',
    key: 'f[id]',
    placeholder: 'Order ID',
    chipDisplayName: 'Order ID',
    inputType: 'number',
  },
  {
    type: 'input',
    key: 'f[invoice.id]',
    placeholder: 'Invoice ID',
    chipDisplayName: 'Invoice ID',
    inputType: 'number',
  },
  {
    type: 'input',
    key: 'f[shipping_address.mobile]',
    placeholder: 'Buyer Phone Number',
    chipDisplayName: 'Buyer Phone Number',
  },
  {
    type: 'range',
    key: 'adjusted_amount',
    placeholder: 'Select Price Range',
    isAdvancedFilter: true,
    chipDisplayName: 'Price',
    label: 'Price',
    isPriceFilter: true,
  },
  {
    type: 'date',
    key: 'created_at',
    placeholder: 'Created at',
    chipDisplayName: 'Created at',
    showRangePreset: true,
    disableFutureDates: true,
  },
  {
    type: 'date',
    key: 'updated_at',
    placeholder: 'Select Date Range',
    chipDisplayName: 'Updated at',
    isAdvancedFilter: true,
    showRangePreset: true,
    disableFutureDates: true,
    label: 'Updated at',
  },
  // {
  //   type: 'infinite-dropdown',
  //   key: 'f[line_items.inventory.warehouse_id][]',
  //   placeholder: 'Pickup Location',
  //   chipDisplayName: 'Pickup Location',
  //   fetch: (params) => getWarehousesListingApi(params, storeId),
  //   options: warehouses,
  //   setter: setWarehouses,
  //   fetchKey: 'warehouses',
  //   queryKey: 'f[id][]',
  //   searchKey: 's[name]',
  //   isAdvancedFilter: true,
  // },
  {
    type: 'infinite-dropdown',
    key: 'f[shipping_address.location.id][]',
    placeholder: 'Select City',
    chipDisplayName: 'City',
    fetch: getCitiesApi,
    options: cities,
    setter: setCities,
    fetchKey: 'locations',
    queryKey: 'f[id][]',
    searchKey: 's[title]',
    isAdvancedFilter: true,
    label: 'City',
  },
  {
    type: 'input',
    key: 's[shipping_address.name]',
    placeholder: 'Search Buyer Name',
    chipDisplayName: 'Buyer Name',
    isAdvancedFilter: true,
    label: 'Buyer Name',
  },
  {
    type: 'dropdown',
    key: 'f[disposition.slug][]',
    placeholder: 'Status',
    chipDisplayName: 'Status',
    options: dispositions,
    mode: 'multiple',
    setAsSlug: true,
  },
  {
    type: 'infinite-dropdown',
    key: 'f[payment_method][]',
    placeholder: 'Payment Method',
    chipDisplayName: 'Payment Method',
    fetch: fetchPaymentMethodsApi,
    fetchKey: 'payment_methods',
    searchKey: 's[name]',
    queryKey: 'f[slug][]',
    options: paymentMethods,
    setter: setPaymentMethods,
    setAsSlug: true,
  },
];

export const SHIPMENTS_FILTERS_LIST = ({
  cities = [],
  setCities,
  paymentMethods = [],
  setPaymentMethods,
  warehouses = [],
  setWarehouses,
  storeId = 1,
}) => [
  {
    type: 'input',
    key: 'f[tracking_number]',
    placeholder: 'CN #',
    chipDisplayName: 'CN #',
  },
  {
    type: 'input',
    key: 'f[order.id]',
    placeholder: 'Order ID',
    chipDisplayName: 'Order ID',
    inputType: 'number',
  },
  // on hold
  // {
  //   type: 'dropdown',
  //   key: 'f[consignment_service_id]',
  //   options: [],
  //   placeholder: 'Courier Service',
  //   chipDisplayName: 'Courier Service',
  // },
  // on hold
  // {
  //   type: 'infinite-dropdown',
  //   key: 'f[line_items.variant.inventories.warehouse.id][]',
  //   placeholder: 'Pickup Location',
  //   chipDisplayName: 'Pickup Location',
  //   fetch: (params) => getWarehousesListingApi(params, storeId),
  //   options: warehouses,
  //   setter: setWarehouses,
  //   fetchKey: 'warehouses',
  //   queryKey: 'f[id][]',
  //   searchKey: 's[title]',
  // },
  {
    key: 'f[shipping_address.location.id][]',
    type: 'infinite-dropdown',
    placeholder: 'City',
    chipDisplayName: 'City',
    fetch: getCitiesApi,
    options: cities,
    setter: setCities,
    fetchKey: 'locations',
    queryKey: 'f[id][]',
    searchKey: 's[title]',
  },
  {
    type: 'infinite-dropdown',
    key: 'f[payment_method.slug][]',
    placeholder: 'Payment Method',
    chipDisplayName: 'Payment Method',
    fetch: fetchPaymentMethodsApi,
    fetchKey: 'payment_methods',
    searchKey: 's[name]',
    queryKey: 'f[slug][]',
    options: paymentMethods,
    setter: setPaymentMethods,
    setAsSlug: true,
  },
];

export const ORDER_ACTIONS_BUTTON_CONFIG = {
  cancelled: {
    type: 'default',
    icon: 'IoIosCloseCircle',
  },
  'cancelled-by-seller': {
    type: 'default',
    icon: 'IoIosCloseCircle',
  },
  rejected: {
    type: 'default',
    icon: 'IoIosCloseCircle',
  },
  'in-transit': {
    type: 'primary',
    icon: 'FaTruckFast',
  },
  delivered: {
    type: 'primary',
    icon: 'FaTruckFast',
  },
  'track-order': {
    type: 'default',
    icon: 'RiMapPinFill',
  },
  returned: {
    type: 'primary-light',
    icon: 'IconAcceptOrder',
  },
  'accept-order': {
    type: 'primary',
    icon: 'IconAcceptOrder',
  },
  'ready-for-pickup': {
    type: 'primary',
    icon: 'IconAcceptReturn',
  },
  'item-returned': {
    type: 'primary',
    icon: 'IconAcceptReturn',
  },
  'print-shipping-label': {
    type: 'primary-light',
    icon: 'HiPrinter',
  },
  'cancelled-by-buyer': {
    type: 'default',
    icon: 'IoIosCloseCircle',
  },
  're-attempt': {
    type: 'default',
    icon: 'MdOutlineRefresh',
  },
  'in-transit-to-seller': {
    type: 'primary',
    icon: 'FaTruckFast',
  },
};
